export default "__VITE_ASSET__4dWz2K54__"